import { SET_YES_NO_SELECTED, SET_YES_NO_SELECTED_OPTION } from "../actions/msTeamsAction";

const initialState = {
    isYesNoSelectedTeams: false,
    yesNoSelectedOption: null,
};

export function msTeamsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_YES_NO_SELECTED:
            return { ...state, isYesNoSelectedTeams: action.payload };
        
        case SET_YES_NO_SELECTED_OPTION:
            return { ...state, yesNoSelectedOption: action.payload };        
        

        default:
            return state;
    }
}
